var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgArrogant = function SvgArrogant(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9645_37834)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37257 18.6274 0 12 0C5.37257 0 0 5.37257 0 12C0 18.6274 5.37257 24 12 24Z",
    fill: "#F7B239"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.69519 18.3047C1.37845 13.9878 1.03829 7.2005 4.67446 2.49414C4.27167 2.80529 3.88411 3.14546 3.51465 3.51492C-1.17155 8.20112 -1.17155 15.799 3.51465 20.4852C8.20085 25.1713 15.7987 25.1714 20.4849 20.4852C20.8543 20.1157 21.1945 19.7281 21.5057 19.3253C16.7994 22.9616 10.012 22.6214 5.69519 18.3047Z",
    fill: "#E09B2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0632 8.37162C17.063 8.37162 17.0632 8.37162 17.0632 8.37162C15.9637 8.37162 14.9707 7.8081 14.4068 6.86433C14.2808 6.65345 14.3496 6.38036 14.5605 6.25441C14.7713 6.1285 15.0444 6.19722 15.1704 6.40811C15.5721 7.08061 16.2797 7.48209 17.0631 7.48214C17.8466 7.48214 18.5542 7.08061 18.9559 6.40811C19.0819 6.19717 19.3552 6.1285 19.5659 6.25441C19.7768 6.3804 19.8455 6.65345 19.7196 6.86433C19.1557 7.80805 18.1626 8.37162 17.0632 8.37162Z",
    fill: "#223137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.93826 8.37163C5.83878 8.37163 4.84575 7.80811 4.28176 6.86434C4.15581 6.65346 4.22457 6.38037 4.43546 6.25442C4.64644 6.12851 4.91948 6.19723 5.04539 6.40812C5.44715 7.08062 6.15476 7.48215 6.93821 7.48215C7.72162 7.48215 8.42914 7.08062 8.83095 6.40812C8.95694 6.19723 9.22999 6.12847 9.44087 6.25442C9.65176 6.38037 9.72052 6.65346 9.59457 6.86434C9.03077 7.80806 8.03774 8.37158 6.93826 8.37163Z",
    fill: "#223137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.6538 13.8912C5.53999 13.8912 5.42613 13.8478 5.33927 13.7609C5.16556 13.5872 5.16556 13.3055 5.33927 13.1319C9.01257 9.45868 14.9895 9.45858 18.6629 13.1319C18.8366 13.3056 18.8366 13.5873 18.6629 13.7609C18.4892 13.9346 18.2076 13.9346 18.0339 13.7609C14.7074 10.4344 9.2948 10.4344 5.96837 13.7609C5.88147 13.8478 5.76761 13.8912 5.6538 13.8912Z",
    fill: "#223137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0112 13.3246C13.9715 13.3246 13.931 13.3192 13.8909 13.308C12.6534 12.961 11.3453 12.9611 10.1079 13.308C9.87157 13.3742 9.62595 13.2363 9.55958 12.9998C9.4933 12.7632 9.6313 12.5178 9.86778 12.4514C11.2622 12.0605 12.7364 12.0604 14.131 12.4514C14.3675 12.5177 14.5055 12.7632 14.4392 12.9998C14.3842 13.1961 14.2056 13.3246 14.0112 13.3246Z",
    fill: "#E09B2D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9645_37834"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrogant, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrogant.ff7ea561.svg";
export { ForwardRef as ReactComponent };